import React from "react";

type Props = {
  label: string;
  description?: string;
  keyName: string;
  value: string;
  currentValue: string | string[];
  img?: string;
  icon?: string;
  iconClass?: string;
  onSelect: (value: string) => void;
};

const formatIconClass = (iconClass?: string): string | undefined => {
  if (!iconClass) return undefined;
  if (iconClass.includes(" ")) return iconClass;
  if (iconClass.startsWith("bi-")) return `bi ${iconClass}`;
  return iconClass;
};

const ImagePickerInput: React.FC<Props> = ({
  label,
  description,
  keyName,
  value,
  currentValue,
  img,
  icon,
  iconClass,
  onSelect,
}) => {
  const isSelected = Array.isArray(currentValue)
    ? currentValue.includes(value)
    : currentValue === value;

  const displayText = (description && description.trim()) || label;

  const iconElement = iconClass ? (
    <i className={formatIconClass(iconClass)} style={{ fontSize: "2rem", color: "#170035" }} aria-hidden="true" />
  ) : icon ? (
    <i className={`bi ${icon}`} style={{ fontSize: "2rem", color: "#170035" }} aria-hidden="true" />
  ) : null;

  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      className={`btn button-input ${isSelected ? "selected" : ""}`}
      aria-pressed={isSelected}
      aria-label={label}
      style={{
        width: "180px",
        minHeight: "180px",
        height: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "12px",
        fontSize: "1rem",
        fontWeight: "normal",
        padding: "1rem",
        gap: "0.75rem",
      }}
    >
      {img && (
        <img src={img} alt="" aria-hidden="true" width="100" style={{ marginBottom: "0.5rem" }} />
      )}
      {iconElement}
      <div style={{ fontSize: "0.9rem", lineHeight: 1.35, textAlign: "center" }}>{displayText}</div>
    </button>
  );
};

export default ImagePickerInput;
